const styles = {
  modal: {
    "button:nth-last-of-type(2)": {
      ml: "auto",
    },
  },
};

export default styles;
